<template>
    <div>
        <preloader v-show="loading"></preloader>

        <div class="form__scope callback-form__regions-formbg callback-form__regions-formbg_success" v-if="isSubmitSuccess">
            <div class="_dflex-block">
                <div class="_w-480">
                    <h2 class="h2">Заявка отправлена</h2>
                    <p class="p1 _mt-16">Наш менеджер свяжется с&nbsp;вами в&nbsp;ближайшее время для подтверждения заявки</p>
                </div>
            </div>
        </div>

        <div class="form__scope callback-form__regions-formbg callback-form__regions-formbg_error" v-if="isSubmitError">
            <div class="_dflex-block">
                <div class="_w-480">
                    <h2 class="h2">Заявка не создана</h2>
                    <p class="p1 _mt-16">Банк уже работает над решением возникшей проблемы. Попробуйте подать заявку позже</p>
                    <a @click.prevent="isSubmitError = false" href="#" class="button button_white _mt-24">Подать заявку</a>
                </div>
            </div>
        </div>

        <div class="form__scope callback-form__regions-formbg" :class="{ '_mb-24-24': marginBtm }" v-if="!isSubmitSuccess && !isSubmitError">
            <div class="_w-592">
                <h2 class="h2">Подать заявку</h2>
                <p class="p1 _mt-16-8">Оставьте заявку на получение льготной ипотеки для регионов РФ. Наш менеджер свяжется с вами в тот же день и поможет заполнить анкету.</p>
                <form
                    onsubmit="return false;"
                    ref="form"
                    class="_mt-32-24"
                >
                    <div class="_dflex-block">
                        <div class="form__input _flex-1 _mr-32-0">
                            <input
                                v-model.trim="$v.fio.$model"
                                :class="{'_invalid': $v.fio.$error && isTrySubmit, '_focus': fio.length}"
                                class="d-input"
                                type="text"
                                name="second_name"
                            >
                            <label
                                    class="form__label"
                                >
                                    Фамилия и имя
                            </label>
                            <p class="form-error" v-if="!$v.fio.required && isTrySubmit">Поле «Фамилия и имя» обязательно для заполнения</p>
                            <p class="form-error" v-if="!$v.fio.cyrWithDash && isTrySubmit">Поле «Фамилия и имя» не должно содержать цифры, спецсимволы и латинские буквы</p>
                            <p class="form-error" v-if="!$v.fio.twoWords && $v.fio.required && isTrySubmit">Поле должно содержать имя и фамилию</p>
                        </div>

                        <div class="form__input _flex-1 _mt-0-32">
                            <input
                                v-model.trim="$v.email.$model"
                                :class="{'_invalid': $v.email.$error && isTrySubmit, '_focus': email.length}"
                                class="d-input"
                                type="email"
                                name="email"
                            >
                            <label
                                    class="form__label"
                                >
                                    E-mail
                            </label>
                            <p class="form-error" v-if="!$v.email.required && isTrySubmit">Поле E-mail обязательно для заполнения</p>
                            <p class="form-error" v-if="!$v.email.email && isTrySubmit">Поле должно содержать корректный e-mail</p>
                        </div>
                    </div>
                    <div class="form__item _mt-32">
                        <div class="form__input">
                            <input
                                v-model.trim="$v.phone.$model"
                                v-phone
                                v-mask="'+7 ### ### ## ##'"
                                :class="{'_invalid': $v.phone.$error && isTrySubmit, '_focus': phone.length}"
                                masked="true"
                                class="d-input"
                                type="tel"
                                name="phone"
                            >
                            <label
                                    class="form__label"
                                >
                                    Телефон
                            </label>
                            <p class="form-error" v-if="!$v.phone.required && isTrySubmit">Поле «Телефон» обязательно для заполнения</p>
                            <p class="form-error" v-if="!$v.phone.minLength  && isTrySubmit">Поле должно содержать не менее 11 символов</p>
                        </div>
                    </div>
                    <mortgage-developers-region
                        class="_mt-32"
                        @getRegionCode="getRegionCode($event)"
                        @getRegionOpened="getRegionOpened($event)"
                        :regions="regions"
                        placeholder="Регион оформления ипотеки"
                        :isTrySubmit="isTrySubmit">
                    </mortgage-developers-region>
                    <div class="_mt-32">
                        <div @click="agreement = !agreement" class="checkbox">
                            <input v-model="agreement" type="checkbox" class="checkbox__input" name="agreement" :class="{'_invalid': $v.agreement.$error}">
                            <label class="checkbox__label">
                                <p>Я соглашаюсь с&nbsp;<a target="_blank" href="/upload/docs/mortgage/agreement.pdf" class="link">условиями&nbsp;использования персональных&nbsp;данных</a> и&nbsp;подтверждаю согласие на&nbsp;использование простой электронной подписи.</p>
                            </label>
                        </div>
                        <p class="form-error" v-if="$v.agreement.$error">Поле обязательное для заполнения.</p>
                    </div>
                    <div class="callback-mortgage__button_wrapper _mt-32">
                        <button
                            type="submit"
                            class="button button_green"
                            @click="tryToSend"
                        >
                            <span>Перейти к оформлению</span>
                        </button>
                    </div>
                    <div class="_mt-24">
                        <div class="form__lock">
                            <span class="ico ico-safety ico_color_gray-dark ico_size_16 _mr-16"></span>
                            <span class="text-small form__lock-text text-gray">Мы защищаем ваши персональные данные, не раскрываем их третьим лицам и не распространяем без Вашего согласия на это, если иное не предусмотрено законодательством</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <modal-with-yandex-captcha
            :requested="modalSmsShow"
            :phone="phone"
            endpoint="mortgageShortApp"
            @closeCaptchaSms="modalSmsShow = false"
            @smsConfirmed="sendForm"
        />
    </div>
    </template>

    <script>
    import { validationMixin } from 'vuelidate';
    import { required, minLength, email } from 'vuelidate/lib/validators';
    import { cyrWithDash, twoWords } from '../../assets/js/vue/validations';
    import mortgageDevelopersRegion from './developers/MortgageDevelopersRegion.vue';
    import axios from 'axios';

    export default {
        name: "CallbackFormCardMortgage",
        mixins: [validationMixin],
        props: {
            corporative: {
                type: Boolean,
                default: false
            },
            calcData: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        components: { mortgageDevelopersRegion },
        data() {
            return {
                fio: '',
                phone: '',
                email: '',
                regionCode: '',
                isDisableSubmit: true,
                isSubmitSuccess: false,
                isSubmitError: false,
                url: '/local/ajax/mortgage.form.php',
                isTrySubmit: false,
                loading: false,
                regions: [],
                regionsUrl: '/rest/v2/network/regions',
                agreement: false,
                marginBtm: false,
                modalSmsShow: false
            };
        },
        validations: {
            fio: {
                cyrWithDash,
                required,
                twoWords
            },
            phone: {
                required,
                minLength: minLength(16),
            },
            email: {
                required,
                email
            },
            agreement: {
                isAgreed: value => value
            }
        },
        methods: {
            getRegionsList() {
                axios.get(this.regionsUrl, {headers: {'Accept': 'application/vnd.api+json'}})
                .then((response) => {
                    this.regions = response.data.data.map((val) => { return {'code':val.attributes.code, 'title': val.attributes.name}});
                })
            },
            getRegionCode(event) {
                this.regionCode = event;
            },
            getRegionOpened(event) {
                this.marginBtm = event;
            },
            tryToSend() {
                this.$v.$touch();
                this.isTrySubmit = true;

                if (!this.$v.$invalid && this.regionCode) {
                    this.$modal.show('apixEnter');
                    this.modalSmsShow = true;
                }
            },
            sendForm() {
                this.$v.$touch();
                this.isTrySubmit = true;

                if (!this.$v.$invalid) {
                    this.loading = true;
                    this.isDisableSubmit = true;

                    if (this.$props.friend !== 'Y') {
                        let fioNew = this.fio.split(/\s+/);
                        let formData = {
                            data: {
                                type: "mortgageShortApp",
                                attributes: {
                                    phone: this.phone.replace(/[\s-()\+]/g, ''), // eslint-disable-line
                                    regionCode: this.regionCode,
                                    applicant: {
                                        firstName: fioNew[1],
                                        lastName: fioNew[0],
                                        calcData: this.calcData
                                    },
                                },
                            }
                        };

                        let url = `/rest/v1/mortgage/app/short?sessid=${window.config.bitrix_sessid}`;
                        axios.post(url, formData, {headers: {'Accept': 'application/vnd.api+json', 'Content-Type': 'application/vnd.api+json'}})
                            .then(() => {
                                this.loading = false;
                                this.isSubmitSuccess = true;
                                this.fio = this.phone = '';
                                this.$v.$reset();
                            })
                            .catch(() => {
                                this.isSubmitError = true;
                                this.loading = false;
                                this.fio = this.phone = '';
                                this.$v.$reset();
                            })
                    }
                    else {
                        this.$modal.hide('mortgage-callback');
                        this.loading = false;
                        this.isDisableSubmit = false;
                    }
                }
            }
        },
        mounted() {
            this.getRegionsList();
        }
    }
    </script>

<style lang="scss" scoped>
    @import '../../assets/scss/base/_variables.scss';
    @import '../../assets/scss/base/_mixins.scss';
    @import '../../assets/scss/base/_functions.scss';

    .callback-form__regions-formbg {
        background-image: url('/local/templates/redesign/src/assets/img/mortgage/regions-form.webp');
        background-color: $grey-106;
        @include fluid('background-size', 488px);
        background-repeat: no-repeat;
        background-position: right;

        @include mobile {
            background-color: $grey-106;
            background-image: none;
        }

        &_success {
            background-image: url('/local/templates/redesign/src/assets/img/mortgage/regions-form_success.webp');
            @include fluid('height', 360px);

            @include mobile {
                background-image: none;
                height: auto;
            }
        }

        &_error {
            background-image: url('/local/templates/redesign/src/assets/img/mortgage/regions-form_error.webp');
            @include fluid('height', 360px);

            @include mobile {
                background-image: none;
                height: auto;
            }
        }
    }

    .callback-form__ok {
        @include fluid('width', 40px);
        @include fluid('height', 40px);
        @include fluid('border-radius', 12px);
        @include fluid('margin-right', 20px);
        background-color: #8BC540;
        background-image: url('/local/templates/redesign/src/assets/img/calculator/good.svg');
        background-repeat: no-repeat;
        background-position: center;
    }

    .checkbox__label {
        @include mobile {
            width: 95%;
        }
    }

    .callback-mortgage__button_wrapper {
        @include mobile {
            width: 95%;
        }
    }
</style>
